const TravelDnaStep = Object.freeze({
  // Route-based preferred-name stage, retained as an identifier.
  YOUR_NAME: 'your-name',

  // Active DNA quiz steps.
  YOUR_PACE: 'your-pace',
  YOUR_STAY: 'your-stay',
  YOUR_SANCTUARY: 'your-sanctuary',
  YOUR_TABLE: 'your-table',
  YOUR_FOOD_PREFERENCES: 'your-food-preferences',
  YOUR_WORLD: 'your-world',
  YOUR_PLANS: 'your-plans',
  YOUR_SPENDING: 'your-spending',
  YOUR_SPLURGES: 'your-splurges',
  YOUR_TRIP: 'your-trip',
  YOUR_DEFAULTS: 'your-defaults',
  YOUR_ACCESSIBILITY: 'your-accessibility',
  ANYTHING_ELSE: 'anything-else',

  // Legacy identifiers retained for saved users and compatibility code.
  YOUR_STANDARD: 'your-standard',
  YOUR_LOCATION: 'your-location',
  YOUR_LIMITS: 'your-limits',
} as const);

export type TravelDnaStep =
  (typeof TravelDnaStep)[keyof typeof TravelDnaStep];

export const allTravelDnaSteps: [TravelDnaStep, ...TravelDnaStep[]] = [
  TravelDnaStep.YOUR_PACE,
  TravelDnaStep.YOUR_STAY,
  TravelDnaStep.YOUR_SANCTUARY,
  TravelDnaStep.YOUR_TABLE,
  TravelDnaStep.YOUR_FOOD_PREFERENCES,
  TravelDnaStep.YOUR_WORLD,
  TravelDnaStep.YOUR_PLANS,
  TravelDnaStep.YOUR_SPENDING,
  TravelDnaStep.YOUR_SPLURGES,
  TravelDnaStep.YOUR_TRIP,
  TravelDnaStep.YOUR_DEFAULTS,
  TravelDnaStep.YOUR_ACCESSIBILITY,
  TravelDnaStep.ANYTHING_ELSE,
];

export default TravelDnaStep;
